export default __webpack_public_path__ + "static/media/Harsh_Logo.f7263aa5.svg";